import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { oneGraphClient } from '../../constants/environment';
import { VEHICLE_BY_AUDICODE } from '../../schemas/VehicleByAudiCode';

const useFetchByAudiCode = (audiCode: string | null) => {
  const { loading, data, error } = useQuery(VEHICLE_BY_AUDICODE, {
    fetchPolicy: 'no-cache',
    client: oneGraphClient,
    skip: !audiCode,
    variables: {
      code: audiCode,
      filterInput: {
        filterByProfileId: 'ngccfront34desktopenv1s',
      },
    },
  });

  const vehicleAudiCodeDetails = useMemo(() => {
    if (!data) return undefined;
    return {
      titleText: data?.carByCode?.carline?.name?.replace(/^Audi\s*/i, ''),
      model: {
        salesModelyear: data?.carByCode?.model?.id?.year,
      },
      subtitleText: data?.carByCode?.model?.name,
      audiCode,
      images: [
        {
          url: data?.carByCode?.media?.images[0]?.url,
        },
      ],
    };
  }, [audiCode, data]);

  return { vehicleAudiCodeDetails, isAudiCodeVehicleLoading: loading };
};

export default useFetchByAudiCode;
